import $ from 'jquery';
window.$ = window.jQuery = $;
import slidersInit from "../components_js/sliders.js";
import formInit from "../components_js/forms.js";
import {turnOffScrollbar, turnOnScrollbar} from "../components_js/header.js";

$(document).ready(function () {
    let $passengerDropdown = $('#passenger-count-dropdown');
    let $passengerCountDropdownBtn = $('.passenger-count .open-dropdown');

    let $minuses = $('.passenger-count__list__item__count-editor .minus');
    if(isOneLeft()){
        $minuses.addClass('disabled');
    }else {
        $minuses.removeClass('disabled');
    }
    let defaultValueOfPassengerCount = $('#passenger-count-value').data('passenger-count');
    updatePassengerText(defaultValueOfPassengerCount);
    const {branchSwiperInit, testimonialsSwiperInit, reasonsSwiperInit} = slidersInit();
    branchSwiperInit(".how-it-works__company");
    branchSwiperInit(".how-it-works__travelers");
    testimonialsSwiperInit();
    reasonsSwiperInit();
    const $bgShadow = $('.bg-shadow');
    const {simpleFormInit, formElementsInit, initializeAirportSearch} = formInit();


    simpleFormInit('#contact-us__form', false);
    formElementsInit();

    let $dropdownOpener = $('[data-dropdown-id]');

    $dropdownOpener.on('click', function (){
        openDropDown($passengerDropdown, $bgShadow);
    })
    let $flightTypeBtn = $('#select2-flight-type-container');
    let $flightTypeDropdown = $('#flight-type__dropdown');
    $flightTypeBtn.on('click', function (){
        openDropDown($flightTypeDropdown, $bgShadow);
    })

    $(document).on('click', function (e){
        if(!$(e.target).is('#passenger-count-dropdown *, #passenger-count-dropdown, .passenger-count *')){
            if (window.innerWidth >= 768){
                $passengerDropdown.fadeOut(300);
            } else {
                $passengerDropdown.slideUp(300);
                turnOnScrollbar();
            }
        }
        if(!$(e.target).is('#flight-type__dropdown *, #flight-type__dropdown, .flight-type-select *')){
            if (window.innerWidth >= 768){
                $flightTypeDropdown.fadeOut(300);
            } else {
                $flightTypeDropdown.slideUp(300);
                turnOnScrollbar();
            }
        }
    })


    $('.passenger-count__list__item__count input').on('input', function (){
        updateCounter($(this));
    })

    $("#passenger-count-dropdown").off("click", ".plus, .minus")
        .on("click", ".plus, .minus", function(e) {
        let inputSelector = $(this).data("input-target"); // берем селектор (#adults / #children / #infants)
        let $input = $(inputSelector);
        let currentVal = parseInt($input.val(), 10) || 0;

        if ($(this).hasClass("plus")) {
            currentVal++;
        } else if ($(this).hasClass("minus") && currentVal > 0 && !isOneLeft()) {
            currentVal--;
        }
        $input.val(currentVal);
        updateCounter($input);
    });

    let $pseudoRadioModal = $('.pseudo__input__modal');
    $('.pseudo__input__btn').on('click', function (){
        turnOffScrollbar();
        $bgShadow.fadeIn(300);
        $pseudoRadioModal.slideDown(300).addClass('modal-opened');
    });

    $('[data-radio-target]').on('click', function (){
        let $target = $(this);
        let inputId = $target.attr('data-radio-target');
        let $input = $(inputId);
        let valueId = $target.attr('data-radio-value');
        $input[0].checked = true;
        $input.trigger('change');
        let value = $input[0].value;
        $(valueId).text(value);
    });

    let $returnInput = $('#return-date');
    $('[name="trip-type"]').on('change', function (){
        let $target = $(this);
        if($target[0].checked) {
            let value = $target[0].value;
            let valueContainer = $target.attr('data-radio-value');
            $(valueContainer).text(value);
        }

        if($target.is('#one-trio') && this.checked){
            $returnInput
                .attr('disabled', true)
                .closest('.input__wrapper')
                .addClass('disabled-input')
                .removeClass('error');
        } else {
            $returnInput
                .attr('disabled', false)
                .closest('.input__wrapper')
                .removeClass('disabled-input');
        }
    });


    if($('#one-trio')[0].checked){
        $returnInput
            .attr('disabled', true)
            .closest('.input__wrapper')
            .addClass('disabled-input')
            .removeClass('error');
    }

    setPositionCalculating([
        {
            'btn' : $passengerCountDropdownBtn[0],
            'dropdown' : $passengerDropdown[0],
            'isAdvanced' : false
        },
        {
            'btn' : $flightTypeBtn[0],
            'dropdown' : $flightTypeDropdown[0],
            'isAdvanced' : false
        }
    ]);

    simpleFormInit('#flights-first-part', false, false, true);

    initializeAirportSearch('#depart', $('#airport-search-modal-1 .select2__wrapper'));
    initializeAirportSearch('#arrive', $('#airport-search-modal-2 .select2__wrapper'));
});


export function setPositionCalculating(btnsAndDropdownsList){
    btnsAndDropdownsList.forEach(entry=>{
        window.addEventListener("resize", () => updatePosition(entry.btn, entry.dropdown, entry.isAdvanced));
        window.addEventListener("scroll", () => updatePosition(entry.btn, entry.dropdown, entry.isAdvanced), true);
        updatePosition(entry.btn, entry.dropdown, entry.isAdvanced);

    })
}
export function updatePosition(button, popup, advanced = true) {
    if (window.innerWidth >= 768) {
        const rect = button.getBoundingClientRect();

        if(advanced){
            // размеры попапа
            const popupHeight = popup.offsetHeight;
            const popupWidth = popup.offsetWidth;

            // начальные координаты
            let top = rect.bottom + window.scrollY + 20;
            let left = rect.left + window.scrollX - 60;

            // проверка выхода за нижнюю границу
            if (top + popupHeight > window.scrollY + window.innerHeight) {
                // открываем над кнопкой (10px зазор)
                top = rect.top + window.scrollY - popupHeight - 10;
            }

            // проверка выхода за правую границу
            if (left + popupWidth > window.scrollX + window.innerWidth) {
                left = window.scrollX + window.innerWidth - popupWidth - 10;
            }

            // проверка выхода за левую границу
            if (left < 0) {
                left = 10;
            }

            popup.style.top = top + "px";
            popup.style.left = left + "px";
        }
        else {
            popup.style.top = rect.bottom + window.scrollY + 20 + "px";
            popup.style.left = rect.left + window.scrollX - 60 + "px";
        }
    }

}

function openDropDown($dropdown, $bgShadow){
    if (window.innerWidth >= 768){
        $dropdown.fadeIn(300);
    } else {
        $dropdown.slideDown(300).addClass('modal-opened');
        $bgShadow.fadeIn(300);
        turnOffScrollbar()
    }
}

function updateCounter($inputElem){
    let value = $inputElem.val();
    $inputElem.css({'width': value.length + 'ch'});

    let $minuses = $('.passenger-count__list__item__count-editor .minus');
    updatePassengerText();
    if(isOneLeft()){
        $minuses.addClass('disabled');
    } else {
        $minuses.each((i, minus)=>{

            let $minusBtn = $(minus);
            let value = $minusBtn
                .closest('.passenger-count__list__item__count-editor')
                .find('.passenger-count__list__item__count input')[0].value;
            if (value == 0){
                $minusBtn.addClass('disabled');
            } else {
                $minusBtn.removeClass('disabled');
            }
        });
    }

}
function updatePassengerText(defaultString) {
    let total = 0;
    if(defaultString){
        const numbers = defaultString.split("/").map(Number);
        total = numbers.reduce((acc, num) => acc + num, 0);
    } else {
        $("#passenger-count-dropdown input[type=number]").each(function() {
            total += parseInt($(this).val(), 10) || 0;
        });
    }

    $("#passenger-count-value").text(total + (total === 1 ? " Passenger" : " Passengers"));
}

function isOneLeft (){
    let text = $("#passenger-count-value").text();
    return text.split(' ')[0] === '1';
}

function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
